import { ObservableInputsManager } from '@/shared/utils/angular-sdk';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { Component, Input, type OnChanges, type OnInit, type SimpleChanges, type Type, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import type {
    TailoredTemplateWidgetConfigurationParams,
    TemplateWidgetConfig,
    TemplateWidgetConfiguration
} from '../../../interfaces/TailoredWidget.interface';
import { TailoredWidgetsProvider } from '../../../providers/tailored-widgets/tailored-widgets.provider';
import type { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';
import { TemplateWidgetClassStaticProvider } from '../template-widget-class.static.provider';

@Component({
    styleUrls: ['./template-widget-spawner.scss'],
    selector: 'template-widget-spawner',
    templateUrl: 'template-widget-spawner.html',
    imports: [AsyncPipe, NgComponentOutlet]
})
export class TemplateWidgetSpawnerComponent implements OnInit, OnChanges {
    private _tailoredWidgetsProvider = inject(TailoredWidgetsProvider);

    private _observableInputsManager = new ObservableInputsManager<TemplateWidgetSpawnerComponent>(this);
    @Input() config!: TemplateWidgetConfig;
    config$ = this._observableInputsManager.observe('config');

    templateWidgetComponent$!: Observable<Type<AbstractTailoredTemplateWidget<TemplateWidgetConfiguration>>>;
    templateWidgetComponentConfig!: TailoredTemplateWidgetConfigurationParams | TemplateWidgetConfiguration | null;

    ngOnInit() {
        this.templateWidgetComponent$ = this.config$.pipe(
            filter(isNotNullish),
            switchMap(config =>
                this._tailoredWidgetsProvider.getTailoredWidgetTemplateById$(config.tailoredWidgetTemplateConfiguration.widgetTemplateId)
            ),
            filter(isNotNullish),
            map(widgetTemplate => widgetTemplate.code),
            map(code => TemplateWidgetClassStaticProvider.getWidgetFromTailoredWidgetTemplateCode(code)),
            tap(() => {
                // Expression could be empty TODO REP-883
                const expression = this.config.tailoredWidgetTemplateConfiguration.templateWidgetConfigurationExpression;
                this.updateWidgetInputs(
                    expression && expression.length > 0
                        ? this.config.tailoredWidgetTemplateConfiguration.templateWidgetConfiguration
                        : this.config.tailoredWidgetTemplateConfiguration.templateWidgetConfigurationParams
                );
            })
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        this._observableInputsManager.triggerChanges(changes);
    }

    updateWidgetInputs(params: TailoredTemplateWidgetConfigurationParams | TemplateWidgetConfiguration | null) {
        if (params) {
            this.templateWidgetComponentConfig = params;
        }
    }
}
